import ButtonV1 from "lib/ButtonV1";
import Label from "lib/Label";
import Image from "lib/Image";
import React, { Fragment, useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./index.scss";
import Toast from "components/ToastComponent";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {checkMaxAttempts} from 'api/user'
import Search_icon from "assets/images/search_icon.svg";
import { Row, Col } from 'react-bootstrap';
import DynamicForm from "components/DynamicForm";
import {  setSelectedData } from "redux/formDisplay";
const PopoverComponent = ({
  trigger,
  triggerWhen,
  placement,
  children,
  show,
  delay,
  handleItemClick,
  fullBodyPresent,
  selectedData, // don't remove using this inside eval
  handleToggle,
  options_key,
  checkPocAttempts,
  checkMaximumAttempts,
  fetchReportingManager,
  is_searchable,
  fetch_internal_poc
}) => {
  const customEval = (condition) => {
    if (!condition) return true;
    else return eval(condition);
  };
  const [toastMessage, setToastMessage] = useState(false);
  const [showPopover, setShowPopover] = useState(undefined);
  const [itemsLength, setItemsLength] = useState(0);

  const navigate = useNavigate();
  const options = children || [];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedOption, setSelectedOption] = useState(null);
  const selectedFormData = useSelector((state) => state.formData?.selectedData);

  const handleSearch = (e) => {
  
    setSearchTerm(e.target.value);
    const filtered = options?.filter((option) =>
      option?.label?.toLowerCase().includes(e.target.value.toLowerCase())
    ) 
    setFilteredOptions(filtered);
  };

  const [formErr, setFormErr] = useState({});
  const stateErrRef = useRef();
  const selectedDataRef = useRef();

  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };
  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef?.current };
    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };

  useEffect(() => {
    if (!fullBodyPresent) {
      let items_length = 0;
      for (const item of children) {
        if (customEval(item.show)) {
          items_length++;
        }
      }
      setItemsLength(items_length);
    } else setItemsLength(1);
  }, [children,selectedData]);

  const onItemClick = async (item,fetchReportingManager) => {
    if(checkPocAttempts){
      checkMaximumAttempts()
    }
    // if (item.id?.includes("send_reminder")) {
    //   let reminderValidtaion = item?.id.split("-");
    //   if(reminderValidtaion.length == 1){
    //     setToastMessage(true);
    //     setTimeout(() => {
    //       setToastMessage(null);
    //     }, 3000);
    //   }
    // }else
     if (item?.id?.includes("distributor_search")) {
      navigate(`/dashboard-listing`);
    }
    setShowPopover(false);
    setTimeout(() => {
      setShowPopover(undefined);
    }, 1);
    handleItemClick(item?.id, item,fetchReportingManager);
    handleToggle && handleToggle(false);
  };
  const popover = (children) => (
    <Popover id="popover-basic" bsPrefix="popover-basic" style={{ zIndex: 2 }}>
      {fullBodyPresent ? (
        children
      ) : (
          <ul className={`${fetch_internal_poc ? 'p-3 shadow overflow-y-auto theme-scrollbar-hover w-300px h-300px' : 'px-1 shadow-sm option_list'}  rounded-0 border-0  mb-2 mx-0 bg-white`}  >    
                {is_searchable && (is_searchable == true && !fetch_internal_poc) ? (
            <>
              <Col xs={12} lg={12} className="px-0">
                <div className="input-wrapper">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Search for people..."
                    className="p-2 outline-0 border-0 border-bottom rounded-0"
                  />
                  <Image imageSrc={Search_icon}  />
                </div>
              </Col>
              {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <ButtonV1
                  key={option.id}
                  className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey"
                  onClick={() => onItemClick(option,fetchReportingManager)}
                  label={option.label}
                  variant="light"
                />
              ))
            ) : (
              <div className="d-flex justify-content-center align-items-center">
          <Label label="No Data Found" className="d-flex justify-content-center" />
        </div>
            )}
            </>
          ) : fetch_internal_poc ? (
            <>
              {fetch_internal_poc?.fields?.map((item, index) => {
                return (
                  <div key={index}>
                    <DynamicForm
                      formFields={item}
                      selectedData={selectedFormData}
                      setSelectedData={setSelectedData}
                      applicantData={selectedData}
                      formErr={formErr}
                      setFormErr={setFormErr}
                      clearFieldError={clearFieldError}
                      setShowPopover={setShowPopover}
                      handleItemClick={handleItemClick}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {children?.map(
                (ele, i) =>
                  customEval(ele?.show) && (
                    <ButtonV1
                      key={i}
                      className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey"
                      onClick={() => onItemClick(ele, fetchReportingManager)}
                      disabled={ele?.disabled ? eval(ele?.disabled) : false}
                      label={ele?.label}
                      variant="light"
                      {...ele}
                    />
                  )
              )}
            </>
          )}
        </ul>
      )}
    </Popover>
  );
  

  if (!itemsLength) {
    return <></>;
  }

  const preventDefault = (e) => {
    e.preventDefault();
  }

  return (
    <>
      {toastMessage && <Toast type="success" message="Reminder sent successfully" autoClose={3000} />}
      <OverlayTrigger
        trigger={triggerWhen ? triggerWhen : "click"}
        placement={placement ? placement : "bottom"}
        overlay={popover(children)}
        delay={{ hide: delay }}
        rootClose
        containerPadding={0}
        flip={true}
        onToggle={handleToggle && handleToggle}
        show={showPopover}
        onHide={() => handleToggle && handleToggle(false)}
      
      >
        {trigger }
      </OverlayTrigger>
    </>
  );
};

export default React.memo(PopoverComponent);
